import React from 'react';
import SvgIcon from 'material-ui/SvgIcon';

let IconArtist = (props) => {
  props = Object.assign({viewBox: '0 0 48 48'}, props);
  return (
    <SvgIcon {...props}>
      <path d="M31.1,8.7c-4.5,0-8.1,3.6-8.1,8.1c0,0.7,0.1,1.3,0.2,1.9c-0.2,0.1-0.4,0.2-0.5,0.3L10.5,33c-0.4,0.5-0.4,1.2,0.1,1.6
	l1.1,1.1l-3,3l0.8,0.8l3-3l1,1c0.2,0.2,0.5,0.3,0.8,0.3c0.3,0,0.5-0.1,0.8-0.3l13.9-12.2c0.2-0.1,0.3-0.3,0.3-0.5
	c0.6,0.1,1.2,0.2,1.9,0.2c4.5,0,8.1-3.6,8.1-8.1C39.2,12.4,35.6,8.7,31.1,8.7z M14.2,36.7l-2.9-2.9l12.2-13.9l4.6,4.6L14.2,36.7z
	 M31.1,23.9c-0.8,0-1.6-0.1-2.4-0.4l-4.2-4.2c-0.3-0.7-0.4-1.5-0.4-2.4c0-1.7,0.6-3.3,1.6-4.5l9.8,9.8
	C34.4,23.2,32.8,23.9,31.1,23.9z M36.4,21.4l-9.8-9.8c1.2-1,2.8-1.6,4.5-1.6c3.9,0,7,3.1,7,7C38.1,18.6,37.4,20.2,36.4,21.4z"/>
    </SvgIcon>
  );
};

IconArtist.displayName = 'IconArtist';
IconArtist.muiName = 'SvgIcon';

export default IconArtist;



// WEBPACK FOOTER //
// ./src/components/Icons/IconArtist.js